import Axios from '../../../networking/interceptor';
import { driver_missed_verifications } from '../../../networking/urlEndPoints';

// Picked Patients page: the driver's "verified missed" tick and comment per
// RX for today. Never changes the delivery status.
export const fetchMissedVerifications = async ({ pharmacyId, winrxDataIds = [] }) => {
	const response = await Axios.get(driver_missed_verifications, {
		params: { pharmacy_id: pharmacyId, winrx_data_ids: winrxDataIds },
	});
	return Array.isArray(response.data?.data) ? response.data.data : [];
};

// Today's verified-missed medicines this driver handed over (accepted by a
// pharmacist). Without asPdf: { count, records }; with asPdf: { encoded_pdf }.
export const fetchHandedOverMissed = async ({ pharmacyId, asPdf = false }) => {
	const response = await Axios.get(`${driver_missed_verifications}/handed-over`, {
		params: { pharmacy_id: pharmacyId, ...(asPdf ? { format: 'pdf' } : {}) },
	});
	return response.data?.data || {};
};

// Called once the PDF is ready, so no blank tab is ever opened. It opens the
// PDF in a new tab; if the browser blocks that (pop-ups off, some app
// wrappers), the PDF is saved as a download instead.
export const openBase64Pdf = (base64Data, fileName = 'verify-missed.pdf') => {
	const binaryString = window.atob(base64Data);
	const bytes = new Uint8Array(binaryString.length);
	for (let i = 0; i < binaryString.length; i++) {
		bytes[i] = binaryString.charCodeAt(i);
	}
	const blob = new Blob([bytes], { type: 'application/pdf' });
	const url = URL.createObjectURL(blob);

	let pdfWindow = null;
	try {
		pdfWindow = window.open(url, '_blank');
	} catch (_) {
		pdfWindow = null;
	}
	if (pdfWindow) {
		setTimeout(() => URL.revokeObjectURL(url), 60000);
		return;
	}

	const link = document.createElement('a');
	link.href = url;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	link.remove();
	setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const saveMissedVerification = async ({ pharmacyId, winrxDataId, isVerifiedMissed, comment, frequencyDoseIds = [] }) => {
	const response = await Axios.post(driver_missed_verifications, {
		pharmacy_id: pharmacyId,
		winrx_data_id: winrxDataId,
		is_verified_missed: Boolean(isVerifiedMissed),
		frequency_dose_ids: frequencyDoseIds,
		comment: comment || '',
	});
	return response.data?.data;
};
